import searchProductLists from '../../components/lists/searchProductLists';

var vue = new Vue({
    el: '#main-wrapper',
    components: {
        searchProductLists,
    },
    data: {
        lists: null,
    },
    computed: {
        
    },
    created: function () {
        var self = this;
        
    },
    mounted: function () {
        this.lists = window.lists;
    },
    methods: {
      
    }
});



// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/views/lists/productLists.js